'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactScroll = require('react-scroll');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Companies = require('./Companies.css');

var _Companies2 = _interopRequireDefault(_Companies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Companies = (_dec = (0, _reactCssModules2.default)(_Companies2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Companies, _Component);

  function Companies(props) {
    (0, _classCallCheck3.default)(this, Companies);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Companies.__proto__ || (0, _getPrototypeOf2.default)(Companies)).call(this, props));

    _this.state = {
      title: 'Publicly-traded companies',
      description: 'We use independent research from non-profit advocacy groups to identify companies within a fund portfolio as sustainability risks.',
      url: _config2.default.domain + _config2.default.routes.companies
    };
    return _this;
  }

  (0, _createClass3.default)(Companies, [{
    key: 'render',
    value: function render() {
      var fffIcon = require('../../../static/images/icons/fff-icn-clr.png');
      var ffbIcon = require('../../../static/images/icons/ffb-icon.svg');
      var ffiIcon = require('../../../static/images/icons/ffi-icon.svg');
      var dffIcon = require('../../../static/images/icons/dff-icn-clr.png');
      var gefIcon = require('../../../static/images/icons/gef-icn-clr.png');
      var gffIcon = require('../../../static/images/icons/gff-icn-clr.png');
      var pffIcon = require('../../../static/images/icons/pff-icn-clr.png');
      var wffIcon = require('../../../static/images/icons/wff-icn-clr.png');
      var tffIcon = require('../../../static/images/icons/tff-icn-clr.png');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement('div', { styleName: 'anchor', id: 'top' }),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'small-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'p',
              null,
              'To calculate sustainability ratings for retirement plans, target date funds, and other mutual funds, we have to know what they\'re invested in. We depend on research from investor research firms and non-profit advocacy groups to identify companies within a fund portfolio as sustainability risks.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Have feedback about our screen lists? ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.contact,
                  title: 'Contact us',
                  xstrong: true
                },
                'Get in touch with us',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'This data is also available as a spreadsheet: ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.iyvSpreadsheet,
                  title: 'Download spreadsheet',
                  xstrong: true
                },
                'Download spreadsheet',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'search-bar-wrap' },
            _react2.default.createElement(_components.AutocompleteSearch, { table: 'companies' })
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'section-heading' },
            'By environmental/social issue'
          ),
          _react2.default.createElement(
            'nav',
            null,
            [[0, 'fossilfuels', 'Fossil fuels'], [1, 'cu200', 'Top carbon reserve owners: Carbon Underground 200™'], [1, 'coal', 'Coal industry'], [1, 'oilgas', 'Oil/gas industry'], [1, 'coalpower', 'Top coal-fired utilities: Macroclimate® 30'], [1, 'utilities', 'Fossil-fired utilities'], [0, 'fossilfinance', 'Fossil fuel finance'], [0, 'fossilinsurance', 'Fossil fuel insurance'], [0, 'deforestation', 'Deforestation'], [1, 'deforestationproducers', 'Deforestation-risk agricultural commodity producer/traders'], [1, 'deforestationfinanciers', 'Banks and lenders'], [1, 'deforestationconsumers', 'Major consumer brands'], [0, 'genderequality', 'Gender equality'], [0, 'civilianfirearms', 'Civilian firearms'], [1, 'gunmanufacturers', 'Gun manufacturers'], [1, 'gunretailers', 'Gun retailers'], [0, 'prisonindustrialcomplex', 'Prison industrial complex'], [1, 'prisonindustry', 'Prison industry'], [1, 'borderindustry', 'Border industry'], [1, 'highriskprisonindustrialcomplex', 'High-risk prison industrial complex'], [1, 'privateprisonoperators', 'Private prison operators'], [0, 'militaryweapons', 'Military weapons'], [1, 'majormilitarycontractors', 'Major military contractors'], [1, 'nuclearweapons', 'Nuclear weapons manufacturers/servicers'], [1, 'clustermunitions', 'Cluster munitions'], [0, 'tobacco', 'Tobacco'], [1, 'tobaccoproducers', 'Tobacco producer/manufacturers'], [1, 'entertainmentcompanies', 'Entertainment companies that promote smoking to kids']].map(function (e, i) {
              return _react2.default.createElement(
                'button',
                {
                  key: e[1],
                  styleName: 'scroll-to-item'
                },
                _react2.default.createElement(
                  _reactScroll.Link,
                  {
                    to: e[1],
                    spy: true,
                    smooth: true,
                    offset: 0,
                    duration: 500,
                    title: e[2]
                  },
                  _react2.default.createElement(
                    'p',
                    { styleName: 'level-' + e[0] },
                    e[2]
                  )
                )
              );
            })
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { styleName: 'content-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'fossilfuels' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: fffIcon,
                  styleName: 'icn',
                  alt: 'Fossil fuels'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Fossil fuels'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The fossil fuel grade is based on the fund\u2019s exposure to five fossil fuel screen lists, tracking several thousand companies primarily in the energy and utility sectors. The grade is also impacted by exposure to companies from the ',
                _react2.default.createElement(
                  _reactScroll.Link,
                  {
                    to: 'fossilfinance',
                    spy: true,
                    smooth: true,
                    offset: 0,
                    duration: 500,
                    title: 'Fossil fuel finance'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'link-look' },
                    'fossil fuel finance screen'
                  )
                ),
                ', and the ',
                _react2.default.createElement(
                  _reactScroll.Link,
                  {
                    to: 'fossilinsurance',
                    spy: true,
                    smooth: true,
                    offset: 0,
                    duration: 500,
                    title: 'Fossil fuel insurance'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'link-look' },
                    'fossil fuel insurance screen'
                  )
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement('div', { styleName: 'anchor', id: 'cu200' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Top carbon reserve owners: Carbon Underground 200\u2122'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.fficu200, title: 'Carbon Underground 200' },
                    'The Carbon Underground 200\u2122'
                  ),
                  ', compiled and maintained by FFI Solutions, identifies the top 100 coal and the top 100 oil and gas publicly-traded reserve holders globally, ranked by the potential carbon emissions content of their reported reserves.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The Carbon Underground 200\u2122 is a proprietary list. Contact ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.fficu200,
                      title: 'Carbon Underground 200 | FFI Solutions',
                      xstrong: true
                    },
                    'FFI Solutions'
                  ),
                  ' for more information.'
                ),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'coal' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Coal industry'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The coal industry screen consists of companies designated by ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.morningstarFff, title: 'Morningstar industry classifications' },
                    'Morningstar industry classifications'
                  ),
                  ' as Thermal Coal or Coking Coal; companies from the ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.gcel, title: 'Global Coal Exit List' },
                    'Global Coal Exit List'
                  ),
                  ' marked as Mining or Services for Coal Industry Sector; and the top 100 coal reserve holders from the ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.fficu200, title: 'Carbon Underground 200' },
                    'Carbon Underground 200\u2122'
                  )
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_co' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'oilgas' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Oil/gas industry'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The oil/gas screen consists of companies designated by ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.morningstarFff, title: 'Morningstar industry classifications' },
                    'Morningstar industry classifications'
                  ),
                  ' as Oil and Gas Drilling, Oil and Gas Extraction and Production, Oil and Gas Equipment and Services, Oil and Gas Integrated, Oil and Gas Midstream, and Oil and Gas Refining and Marketing; upstream and midstream companies from the ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.gogel, title: 'Global Oil/Gas Exit List' },
                    'Global Oil/Gas Exit List'
                  ),
                  '; and the top 100 oil/gas reserve holders from the ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.fficu200, title: 'Carbon Underground 200' },
                    'Carbon Underground 200\u2122'
                  ),
                  '.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_og' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'coalpower' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Top coal-fired utilities: Macroclimate\xAE 30'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.macroclimate50, title: 'Macroclimate 30\xAE' },
                    'Macroclimate\xAE 30'
                  ),
                  ' is an exclusion list of the 30 largest public-company owners of coal-fired power plants in Developed Markets plus China and India. Macroclimate\xAE compiled the list of 30 companies using open-source data on coal-fired power plants worldwide.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_f15' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'utilities' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Fossil-fired utilities'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The fossil-fired utilities screen consists of companies designated by ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.morningstarFff, title: 'Morningstar industry classifications' },
                    'Morningstar industry classifications'
                  ),
                  ' as Utilities-Independent Power Producers, Utilities-Renewable, Utilities-Diversified, Utilities-Regulated Electric, and Utilities-Regulated Gas. (Despite the name, the Utilities-Renewable industry classification includes companies that distribute gas and/or burn fossil fuel for power generation.) It also includes companies from the ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.gcel, title: 'Global Coal Exit List' },
                    'Global Coal Exit List'
                  ),
                  ' marked as Power for Coal Industry Sector. We remove any companies in these categories that are engaged in 100% renewable operations, pure transmission, or otherwise don\'t distribute gas or burn fossil fuels to generate power. We also remove a small number of utilities that have fossil fuel operations but meet the criteria for inclusion on our ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.clean200Fff, title: 'Clean200' },
                    'Clean200'
                  ),
                  ' screen - USD revenue of at least $1 billion, and over 50% of total revenues are from green sources, as measured by Corporate Knights Research.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_ut' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'fff' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'fff' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'fossilfinance' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: ffbIcon,
                  styleName: 'icn',
                  alt: 'Fossil fuel finance'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Fossil fuel finance'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The fossil fuel finance grade is based on the fund\u2019s exposure to banks that provide lending to fossil fuels.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Banks financing fossil fuels'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The fossil fuel finance screen consists of 60 of the largest commercial and investment banks, from the ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: 'https://www.bankingonclimatechaos.org/',
                      title: 'Banking on Climate Chaos',
                      xstrong: true
                    },
                    'Banking on Climate Chaos'
                  ),
                  ' report. The data tracks the total fossil fuel financing of these banks over 2016-2023: lending, and underwriting debt and equity issuances.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_fossil_bank' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'ffb' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'ffb' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'fossilinsurance' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: ffiIcon,
                  styleName: 'icn',
                  alt: 'Fossil fuel insurance'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Fossil fuel insurance'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The fossil fuel insurance grade is based on the fund\u2019s exposure to insurers that underwrite and invest in fossil fuels.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Insurance companies underwriting fossil fuels'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The fossil fuel insurance screen consists of 30 of the largest primary insurers and reinsurers, from the ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: 'https://docs.google.com/spreadsheets/d/157kNo3-xg7qeVHi8SF21VqjXKrSjHixL9UOKFTp8PKQ/edit#gid=769793980',
                      title: 'Insure Our Future Scorecard',
                      xstrong: true
                    },
                    'Insure Our Future Scorecard'
                  ),
                  '. The data rates the fossil fuel insurance policies of these companies.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_fossil_insure' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'ffi' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'ffi' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'deforestation' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: dffIcon,
                  styleName: 'icn',
                  alt: 'Deforestation'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Deforestation'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The deforestation grade is based on the fund\u2019s exposure to a list of deforestation-risk companies identified in partnership with ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://foe.org/' },
                  'Friends of the Earth U.S.'
                ),
                ', compiled from independent research as well as from existing resources within the civil society research and investor advocacy communities on forest-risk companies, including ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://forestsandfinance.org/', target: '_blank',
                    title: 'Forests & Finance' },
                  'Forests & Finance'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://forest500.org/', target: '_blank', title: 'Forest500' },
                  'Forest500'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.cdp.net/en/forests', target: '_blank', title: 'CDP Forests' },
                  'CDP Forests'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://supply-change.org/', target: '_blank',
                    title: 'Supply Change.org' },
                  'Supply Change.org'
                ),
                ' and ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.spott.org/', target: '_blank', title: 'ZSL SPOTT' },
                  'ZSL SPOTT'
                ),
                '. The screens include deforestation-risk agricultural commodity producer/traders (palm oil, paper/pulp, rubber, timber, cattle, and soy); financial companies involved in lending and underwriting to deforestation-risk producers and traders; and major consumer goods companies that source from deforestation-risk producers and traders.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with investments in producer/traders considered a higher risk.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement('div', { styleName: 'anchor', id: 'deforestationproducers' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Deforestation-risk agricultural commodity producer/traders'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy, and have a past record or a significant risk of contributing to deforestation, land grabbing, and human rights abuses.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_po_producer' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'deforestationfinanciers' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Banks and lenders'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Financial institutions directly and indirectly involved in underwriting and lending to deforestation-risk producers and traders. These are the publicly listed banks drawn from the platform ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: 'https://forestsandfinance.org/',
                      title: 'Forests & Finance',
                      xstrong: true
                    },
                    'Forests & Finance'
                  ),
                  '.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_po_financier' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'deforestationconsumers' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Major consumer brands'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Consumer goods retailers that source palm oil, paper/pulp, rubber, timber, cattle, and soy from deforestation-risk producers and traders and sell it to consumers worldwide.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_po_consumer' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'dff' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'dff' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'genderequality' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: gefIcon,
                  styleName: 'icn',
                  alt: 'Gender equality'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Gender equality'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The gender equality grade is based on corporate data from ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://equileap.com/' },
                  'Equileap'
                ),
                ' that tracks how companies perform on four gender equality subcategories: gender balance in leadership and workforce; equal compensation and work life balance; policies promoting gender equality; and commitment, transparency, and accountability.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The Equileap Gender Equality Scorecard is a proprietary dataset. Contact ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://equileap.com/',
                    title: 'Equileap',
                    xstrong: true
                  },
                  'Equileap'
                ),
                ' for more information.'
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'gef' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'gef' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'civilianfirearms' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: gffIcon,
                  styleName: 'icn',
                  alt: 'Civilian firearms'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Civilian firearms'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The civilian firearm grade is based on the fund\u2019s exposure to two screen lists: civilian firearm manufacturers, and retailers that sell firearms or ammunition to the civilian market.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with investments in civilian firearm manufacturers considered a higher risk.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement('div', { styleName: 'anchor', id: 'gunmanufacturers' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Gun manufacturers'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The leading publicly-traded companies involved in manufacturing civilian firearms including handguns, rifles, assault weapons, and ammunition.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_gm' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'gunretailers' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Gun retailers'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Large publicly-traded companies that sell firearms or ammunition to the civilian market.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_gr' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'gff' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'gff' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'prisonindustrialcomplex' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: pffIcon,
                  styleName: 'icn',
                  alt: 'Prison industrial complex'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Prison industrial complex'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The prison industrial complex grade is based on the fund\u2019s exposure to two screen lists: prison industry companies, and border industry companies. All the companies on both lists are identified by the ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://investigate.afsc.org/' },
                  'American Friends Service Committee\u2019s Investigate project'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with both the prison industry and border industry screens having a subset of companies considered a higher risk. '
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement('div', { styleName: 'anchor', id: 'prisonindustry' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Prison industry'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The prison industry screen flags companies involved in incarceration and detention facilities (including facility management, youth and family detention, private facilities internationally, private prison financing, transportation and deportations, facility surveillance and security, and prison labor), services in facilities (including communication services, health services, banking and financial services, and food, commissary, and other goods), and supervision and monitoring (including e-carceration, community corrections, and bail bonds).'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_pp' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'borderindustry' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Border industry'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The border industry screen flags companies involved in incarceration and detention facilities (including facility management, youth and family detention, private prison financing, facility surveillance and security, transportation and deportations, and prison labor), militarization of the U.S.-Mexico border (including border construction and maintenance and border monitoring and surveillance), and immigrant monitoring and surveillance (including high-tech surveillance of immigrants, e-carceration, and bail bonds).'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_borders' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'highriskprisonindustrialcomplex' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'High-risk prison industrial complex'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The high-risk prison industrial complex screen flags companies from the prison industry and border industry screens that are recommended for divestment by the American Friends Service Committee state violence criteria.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_pff_high' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'privateprisonoperators' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Private prison operators'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For-profit private contractors that have contracts with cities, counties, states, and the federal government to operate prisons, jails, and immigration jails. Any investments in these companies earn a fund an automatic F.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_pff_extreme' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'pff' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'pff' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'militaryweapons' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: wffIcon,
                  styleName: 'icn',
                  alt: 'Military weapons'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Military weapons'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Our analysis checks funds for direct stock investments in military contractors. This list includes two sub-categories: manufacturers and servicers of nuclear weapons; and current and recent manufacturers of controversial weapons, such as cluster munititions, anti-personnel landmines, incendiary weapons, and depleted uranium. To identify these companies, we used data from over 20 ethical investment firms, industry news outlets, and non-profit advocacy groups, including the ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.sipri.org/databases/armsindustry', title: 'Stockholm International Peace Research Institute (SIPRI) Arms Industry Database' },
                  'Stockholm International Peace Research Institute (SIPRI) Arms Industry Database'
                ),
                ', and ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.paxNuclearWeapons, title: 'Risky Returns' },
                  'peace groups PAX and ICAN'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'For more information on how we identified these companies, visit ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.wff, xstrong: true, title: 'Weapon Free Funds' },
                  'Weapon Free Funds'
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement('div', { styleName: 'anchor', id: 'majormilitarycontractors' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Military contractors'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Companies identified as having significant involvement in arms manufacturing and/or military contracting by one or more of over 20 data sources. Each company on the list was identified by at least one ethical investment firm for exclusion for reasons of involvement with military weapons.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_mmc' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'nuclearweapons' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Nuclear weapons manufacturers/servicers'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Companies identified as having involvement with the production of nuclear weapons.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_nw' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'clustermunitions' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Controversial weapons'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Companies identified as having involvement with the production of controversial weapons, such as cluster munititions, anti-personnel landmines, incendiary weapons, and depleted uranium.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_cm' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'wff' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'wff' }),
              _react2.default.createElement(_components.ScrollToTop, null),
              _react2.default.createElement('hr', null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-section-div' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'tobacco' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', {
                  src: tffIcon,
                  styleName: 'icn',
                  alt: 'Tobacco'
                })
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Tobacco'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The tobacco grade is based on the fund\u2019s exposure to two screen lists: tobacco companies that either produce tobacco or manufacture tobacco products identified by industry classifications; and a list of entertainment companies that promote tobacco to young audiences, identified by research from the ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://smokefreemovies.ucsf.edu/whos-accountable', target: '_blank',
                    title: 'UCSF Smoke Free Movies Database' },
                  'University of California, San Francisco Center for Tobacco Control Research and Education Smoke Free Movies Database'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with investments in tobacco producer/manufacturers considered a higher risk.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'indent' },
                _react2.default.createElement('div', { styleName: 'anchor', id: 'tobaccoproducers' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Tobacco producer/manufacturers'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Identified using Morningstar industry categories, these companies either produce tobacco or manufacture tobacco products.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_to' }),
                _react2.default.createElement('div', { styleName: 'anchor', id: 'entertainmentcompanies' }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Entertainment companies that promote smoking to kids'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'There is scientific consensus that exposure to tobacco in movies causes kids to begin smoking. These entertainment companies promote smoking by producing kid-rated movies that depict smoking.'
                ),
                _react2.default.createElement(_components.ScreenedCompaniesList, { screen: 'is_tm' })
              ),
              _react2.default.createElement(_components.TargetDateSeriesIssueLink, { iyvCode: 'tff' }),
              _react2.default.createElement(_components.TargetDateSeriesPartnerLogos, { iyvCode: 'tff' }),
              _react2.default.createElement(_components.ScrollToTop, null)
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return Companies;
}(_react.Component)) || _class);
exports.default = Companies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Companies/Companies.js
// module id = 1468
// module chunks = 0